const API_BASE_URL = process.env.REACT_APP_API_BASE_URL
import { request } from 'modules/client'

let route = `${API_BASE_URL}/networks`

export class NetworksService {

	static getNetworks(appId) {
		return request(route, {
			method: 'GET',
			headers: { 'appId': appId }
		});
	}

	static getNetwork(params) {
		return request(`${route}/${params.networkId}`, {
			method: 'GET',
			headers: { 'appId': params.dappId }
		})
	}

	static saveNetwork(data) {
		return request(route, {
			method: 'POST',
			headers: { 'appId': data.appId },
			payload: data
		})
	}

	static updateNetwork(data) {
		return request(`${route}/${data._id}`, {
			method: 'PUT',
			headers: { 'appId': data.appId },
			payload: data
		})
	}

	static deleteNetwork(data) {
		return request(`${route}/${data._id}`, {
			method: 'DELETE',
			headers: { 'appId': data.appId },
		})
	}
}